
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import clsxm from '@/lib/clsxm';
import formatDate from '@/lib/formatDate';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
import { getAllPostsForHome } from '@/utils/wordpress';
interface Article {
    title: string;
    slug: string;
    description: string;
    date: string;
    featuredImage: string;
    author: any;
    excerpt: string;
}
interface BlogProps {
    articles: any[];
}
const Blog = ({ articles }: BlogProps) => {
    return (<main className='dark:bg-slate-900'>
      <Seo templateTitle='AI Blog'/>
      <div className='relative '>
        <div className='mx-auto'>
          <div className='z-1 relative pb-8 sm:pb-16 md:pb-20 lg:w-full'>
            <LandingPageNavigation />
          </div>
        </div>
      </div>
      <div className='relative bg-gray-50 dark:bg-slate-700 px-4 pt-16 pb-20 sm:px-6 lg:px-8 lg:pt-24 lg:pb-28'>
        <div className='absolute inset-0'>
          <div className='h-1/3 bg-white dark:bg-slate-900 sm:h-2/3'/>
        </div>
        <section className='relative mx-auto max-w-7xl'>
          <div className='text-center'>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
              From the blog
            </h2>
            <p className='mx-auto mt-3 max-w-2xl text-xl text-gray-500 sm:mt-4'>
              If you're looking for insights on how artificial intelligence can
              help you create better content, you've come to the right place.
            </p>
          </div>
          <div className='mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3'>
            {articles.map(({ node }) => (<PostPreview key={node.slug} title={node.title} coverImage={node.featuredImage} date={node.date} author={node.author} slug={node.slug} excerpt={node.excerpt}/>))}
          </div>
        </section>
      </div>
      <Footer />
    </main>);
};
export function PostPreview({ title, coverImage, date, excerpt, author, slug, }: any) {
    return (<div className='flex flex-col overflow-hidden rounded-lg shadow-lg'>
      <div className='flex-shrink-0'>
        <Link href={`/blog/${slug}`}>
          <Image className='h-48 w-full object-cover' src={coverImage?.node.sourceUrl} alt={title} width={500} height={500}/>
        </Link>
      </div>
      {/* <div className='mb-5'>
          {coverImage && (
            <CoverImage title={title} coverImage={coverImage} slug={slug} />
          )}
        </div> */}
      <div className='flex flex-1 flex-col justify-between bg-white dark:bg-slate-800 p-6'>
        <div className='flex-1'>
          <Link href={`/blog/${slug}`} className='mt-2 block'>
            <p className='text-xl font-semibold text-gray-900 dark:text-slate-100' dangerouslySetInnerHTML={{ __html: title }}></p>
            <p className='mt-3 text-base text-gray-500 dark:text-slate-300' dangerouslySetInnerHTML={{ __html: excerpt }}></p>
          </Link>
        </div>
        <div className='mt-6 flex items-center'>
          <div className='flex-shrink-0'>
            <a>
              <span className='sr-only'>{author?.node?.name}</span>
              <img className='h-10 w-10 rounded-full' src={author.node.avatar.url} alt=''/>
            </a>
          </div>
          <div className='ml-3'>
            <p className='text-sm font-medium text-gray-900 dark:text-slate-500'>
              <a className='hover:underline'>{`${author.node.firstName} ${author.node.lastName || ''}`}</a>
            </p>
            <div className='flex space-x-1 text-sm text-gray-500 dark:text-slate-500'>
              <time dateTime={formatDate(date)}>{formatDate(date)}</time>
            </div>
          </div>
        </div>
      </div>
      {/* <h3 className='text-3xl mb-3 leading-snug'>
          <Link
            href={`/blog/${slug}`}
            className='hover:underline'
            dangerouslySetInnerHTML={{ __html: title }}
          ></Link>
        </h3>
        <div className='text-lg mb-4'>{formatDate(date)}</div>
        <div
          className='text-lg leading-relaxed mb-4'
          dangerouslySetInnerHTML={{ __html: excerpt }}
        /> */}
      {/* <Avatar author={author} /> */}
    </div>);
}
export function Avatar({ author }: any) {
    const isAuthorHaveFullName = author?.node?.firstName && author?.node?.lastName;
    const name = isAuthorHaveFullName
        ? `${author.node.firstName} ${author.node.lastName}`
        : author?.node?.name || null;
    if (!author) {
        return null;
    }
    console.log(author);
    return (<div className='flex items-center mt-3'>
      <div className='w-10 h-10 relative mr-4'>
        <img src={author.node.avatar.url} className='rounded-full' alt={name}/>
      </div>
      <div className='text-sm font-medium'>{name}</div>
    </div>);
}
interface CoverImageProps {
    title: string;
    coverImage: {
        node: {
            sourceUrl: string;
        };
    };
    slug?: string;
}
export function CoverImage({ title, coverImage, slug }: CoverImageProps) {
    const image = (<Image width={2000} height={1000} alt={`Cover Image for ${title}`} src={coverImage?.node.sourceUrl} className={clsxm('shadow-small', {
            'hover:shadow-medium transition-shadow duration-200': slug,
        })}/>);
    return (<div className='sm:mx-0'>
      {slug ? (<Link href={`/blog/${slug}`} aria-label={title}>
          {image}
        </Link>) : (image)}
    </div>);
}
export default Blog;
const getStaticProps: GetStaticProps = async ({ preview = false, locale, }) => {
    const allPosts = await getAllPostsForHome(preview);
    //redirect 301 to the /blog
    // if (locale !== 'en') {
    //   return {
    //     redirect: {
    //       destination: `/blog`,
    //       permanent: true,
    //     },
    //   };
    // }
    return {
        props: { articles: allPosts['edges'], preview },
        revalidate: 10,
    };
};

    async function __Next_Translate__getStaticProps__1a1052e906d__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1052e906d__ as getStaticProps }
  